import { queryFor } from "@visioni/a3s-client-api/app";
import {
  listReportsEndpoint,
  getReportEndpoint,
  getReportByIdEndpoint,
  getReportSnapshotUrlEndpoint,
  getReportArtifactUrlEndpoint,
} from "../client-messages";

/**
 * React Query options factories for the reports endpoints.
 *
 * Each factory derives its queryKey, URL builder, and decode boundary from a
 * single `defineEndpoint` definition, so the contract surface (path,
 * pathParams, querySchema, responseSchema) lives in `client-messages` exactly
 * once. Pattern mirrored from `features/a3s-upsell/src/app/queries.ts`.
 *
 * `apiConfig.tenant` carries the tenantId — callers pass only the extra path
 * params.
 */

export const reportsListQuery = queryFor(listReportsEndpoint);
export const reportItemByIdQuery = queryFor(getReportByIdEndpoint);
export const reportSnapshotUrlQuery = queryFor(getReportSnapshotUrlEndpoint);

/**
 * Presigns one per-site artifact (render `.json` OR download `.xlsx`) for a
 * multi-file report. The `key` query param is the opaque S3 key the listing row
 * carries for the site; the server validates + structurally guards it. Used by
 * RoadSense to fetch the render payload and to build the workbook download link.
 */
export const reportArtifactUrlQuery = queryFor(getReportArtifactUrlEndpoint);

/** WasteSense-legacy; new types use {@link reportItemByIdQuery}. */
export const reportItemQuery = queryFor(getReportEndpoint);
